/*
 * THTD — Storefront view/select event dispatchers (T3 / T4 / T6)
 * Emits the non-cart-write Standard Storefront Events by reading server-rendered payloads
 * (built with the official `standard_event_data` Liquid filter) and bridging Udesly's
 * existing client-side variant signal. No fetch wrapping here; pure additive dispatch.
 *
 *   shopify:page:view        — every page (template from <body class="template-…">)
 *   shopify:product:view     — PDP, from a server payload (default + custom-jersey sections)
 *   shopify:product:select   — bridged from Udesly's `foundVariation` (augmented variant JSON)
 *   shopify:cart:view         — drawer open (wf-change-cart-state) and the /cart page
 *   shopify:collection:view  — collection page, from a server payload
 *
 * Observability only. Every handler is wrapped so a failure can never break the page.
 * Loaded after the readiness bootstrap; gated on THTD.onSEReady.
 */
(function () {
  if (window.__thtd_storefront_events) return;
  window.__thtd_storefront_events = true;
  if (!(window.THTD && window.THTD.onSEReady)) return;

  function payload(name) {
    var el = document.querySelector('script[type="application/json"][data-thtd-se="' + name + '"]');
    if (!el) return null;
    try { var v = JSON.parse(el.textContent); return (v && typeof v === 'object') ? v : null; } catch (e) { return null; }
  }
  function templateFromBody() {
    var m = /(?:^|\s)template-([^\s]+)/.exec(document.body && document.body.className || '');
    return m ? m[1] : '';
  }
  function dispatchSafe(make) {
    try { var ev = make(); if (ev) document.dispatchEvent(ev); } catch (e) { /* never break the page */ }
  }
  function onReady(fn) {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn, { once: true });
    else fn();
  }

  window.THTD.onSEReady(function (SE) {
    if (!SE) return;

    // ---- page:view (every page) ----
    onReady(function () {
      if (!SE.PageViewEvent) return;
      dispatchSafe(function () {
        return new SE.PageViewEvent({ page: { template: templateFromBody(), title: document.title, url: location.href } });
      });
    });

    // ---- product:view (PDP) ----
    onReady(function () {
      var pl = payload('product:view');
      if (!pl || !SE.ProductViewEvent) return;
      dispatchSafe(function () { return new SE.ProductViewEvent(pl); });
    });

    // ---- collection:view ----
    onReady(function () {
      var pl = payload('collection:view');
      if (!pl || !SE.CollectionViewEvent) return;
      dispatchSafe(function () { return new SE.CollectionViewEvent(pl); });
    });

    // ---- cart:view (page) — only on the /cart template (server payload present) ----
    onReady(function () {
      var pl = payload('cart:view');
      if (!pl || !SE.CartViewEvent) return;
      dispatchSafe(function () { return new SE.CartViewEvent(pl); });
    });

    // ---- product:select — bridge Udesly's foundVariation (fires on document.body) ----
    if (SE.ProductSelectEvent) {
      var optNames = payload('option-names') || [];
      document.body.addEventListener('foundVariation', function (e) {
        var v = e && e.detail && e.detail.variation;
        if (!v) return;
        try {
          var selectedOptions = [v.option1, v.option2, v.option3]
            .map(function (val, i) { return val ? { name: (optNames[i] && (optNames[i].name || optNames[i])) || ('option' + (i + 1)), value: val } : null; })
            .filter(Boolean);
          var deferred = SE.ProductSelectEvent.createPromise();
          var ev = new SE.ProductSelectEvent({
            product: { handle: location.pathname.split('/').filter(Boolean).pop() },
            selectedOptions: selectedOptions,
            promise: deferred.promise
          });
          document.dispatchEvent(ev);
          deferred.resolve({ variant: {
            id: v.id != null ? String(v.id) : null,
            availableForSale: !!v.available,
            price: (v.price_amount != null) ? { amount: String(v.price_amount), currencyCode: v.currency || null } : null,
            selectedOptions: selectedOptions
          }});
        } catch (err) { /* never break variant selection */ }
      }, true);
    }

    // ---- cart:view (dialog) — Udesly drawer opens via wf-change-cart-state {open:true} ----
    if (SE.CartViewEvent) {
      document.addEventListener('wf-change-cart-state', function (e) {
        if (!e || !e.detail || !e.detail.open) return;
        window.THTD.cartJSON(window.fetch).then(function (ajax) {
          dispatchSafe(function () {
            var cart;
            try { cart = SE.CartViewEvent.createCartFromAjaxResponse ? SE.CartViewEvent.createCartFromAjaxResponse(ajax) : ajax; }
            catch (x) { cart = ajax; }
            return new SE.CartViewEvent({ context: 'dialog', cart: cart });
          });
        }).catch(function () {});
      }, true);
    }
  });
})();
